<template>
  <v-container class="p-4">
    <section class="d-flex flex-column flex-sm-row justify-content-between">
      <div class="ml-1 my-3">
        <div class="text-caption grey--text text--darken-1">Abastecimiento · Centro de distribución</div>
        <h2 class="font-weight-medium mb-0">Reservas del cubicador</h2>
      </div>
      <v-breadcrumbs :items="breadcrumb"></v-breadcrumbs>
    </section>
    <p class="ml-1 grey--text text--darken-2">
      Solicitudes del cubicador que ya llegaron a SAP, en orden de la cola de despacho. Abre una
      fila para ver qué le falta para salir a picking: compra, stock y ventana de picking.
    </p>
    <cubicador-bundles-table mode="all" :show-admin-actions="true"></cubicador-bundles-table>
  </v-container>
</template>

<script>
import CubicadorBundlesTable from "@/components/commons/CubicadorBundlesTable.vue";

export default {
  components: {
    CubicadorBundlesTable,
  },
  data() {
    return {
      breadcrumb: [
        {
          text: "Proyectos",
          disabled: false,
          href: "/",
        },
        {
          text: "Reservas del cubicador",
          disabled: true,
          href: "/supplying/cd/cubicador-reservas",
        },
      ],
    };
  },
};
</script>
